<template>
  <div class="popup">
    <div class="backdrop" @click="$emit('close-popup')"></div>
    <div class="popupItem">
      <a-tooltip title="close">
        <div class="cross" @click="$emit('close-popup')">X</div>
      </a-tooltip>

      <div v-if="imageUrl">
        <div class="image-wrapper">
          <img class="popup-img" :src="item.image" :alt="item.name" />
        </div>
        <div class="cstagscontainer-vd" v-if="item.cs_tags.name">
          <div class="cstagstext-vd">{{ item.cs_tags.name }}</div>
        </div>
      </div>
      <div v-else>
        <img
          class="popup-img"
          src="../../../assets/images/default-img.jpg"
          :alt="item.name"
        />
        <div class="cstagscontainer-vd" v-if="item.cs_tags.name">
          <div class="cstagstext-vd">{{ item.cs_tags.name }}</div>
        </div>
      </div>
      <div class="product-info">
        <div class="product-names">
          <div class="name" id="product-name">{{ item.name }}</div>

          <div class="tagscontainer">
            <div v-for="item in tags" v-bind:key="item.id" class="tagsstyle">
              {{ item }}
            </div>
          </div>

          <div class="prices">
            <div
              v-if="Number(item.before_price) > Number(item.after_price)"
              class="price beforeprice"
            >
              Rs.{{ item.before_price }}
            </div>

            <div class="price">Rs.{{ item.after_price }}</div>
          </div>

          <div class="des-name popup-description">
            {{ item.short_description }}
          </div>

          <a class="view-details" :href="getVUrl(item.id)"> View Details </a>

          <div class="order-button-wrap">
            <a-tooltip>
              <template slot="title">Add to cart</template>
              <div
                class="add"
                :class="{ active: !add }"
                @click="addToCartCall(item)"
              >
                Add
              </div>
            </a-tooltip>
            <div class="added" :class="{ active: add }">
              <a-button
                class="order-button minus"
                icon="minus"
                @click="decreaseQuantity(item.id)"
              />
              {{ quantity }}
              <a-button
                class="order-button plus"
                icon="plus"
                @click="increaseQuantity(item.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CartData } from "../../../services/storage.service";
import isUrl from "../../../utils/isUrl";
import { LocationId } from "../../../services/storage.service";

export default {
  name: "ProductPopup",
  props: ["item"],
  data() {
    return {
      add: false,
      quantity: 1,
      itemId: null,
      imageUrl: false,
      popUpOn: 0,
      tags: [],
    };
  },
  created() {
    this.itemId = this.item.id;

    if (this.item.image !== "") {
      if (isUrl(this.item.image)) {
        this.imageUrl = true;
      }
    }
    if (this.cartItems.filter((food) => food.id === this.item.id).length > 0) {
      this.add = true;
    }

    let itemtags = this.item.tags.split(",");
    this.tags = itemtags.filter((data) => data);
  },
  watch: {
    // whenever question changes, this function will run
    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((food) => food.id === this.itemId).length === 0
      ) {
        (this.add = false), (this.quantity = 1);
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },
  methods: {
    ...mapActions(["addToCart", "addQuantity", "minusQuantity", "deleteItem"]),
    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },
    getVUrl: function (item) {
      if (LocationId.getLocationId() == 1) return "/ktm/i/" + item;
      else if (LocationId.getLocationId() == 2) return "/pkr/i/" + item;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .popup-img {
    width: 300px;
    height: 300px; // remove later
    border-radius: 10px;
    object-fit: cover; //remove later
  }
}

.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;

  .backdrop {
    widows: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
  .popupItem {
    padding: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: red;
    border-radius: 10px;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);

    .cross {
      color: white;
      // position: absolute;
      border: 1px solid #ed2027;
      background: #ed2027;
      // display: inline-block;
      text-align: center;
      font-size: 11px;
      cursor: pointer;
      // background: red;
      display: flex;
      justify-content: center;
      align-items: center;
      // height: 20px;
      // width: 20px;
      border-radius: 10px;
    }
  }
}

.product-info {
  display: flex;
  // height: 300;
  // background-color: blue;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  margin-top: 10px;

  .rating-star {
    margin-bottom: 10px;
    i {
      color: #fbce1d;
      font-size: 12px;
      margin: 0 1px;
    }
  }
  .product-names {
    padding: 5px 5px, 10px, 5px;
    .name {
      line-height: 1.5em;
      text-transform: capitalize;
      font-weight: 600;
      font-size: 14px;
      color: #27272f;
      min-height: 0px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
  .price {
    margin: 10px 0px;
    color: $brand-color;
    font-size: 16px;
    font-weight: 500;
    width: 75px;
  }
  .order-button-wrap {
    font-family: $main-font;
    background: $brand-color;
    border: none;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    line-height: 30px;
    position: relative;
    text-align: center;
    margin: 0 auto;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 140px;
    padding: 5px;
    .add {
      display: none;
      padding: 0 20px;
      cursor: pointer;
      &.active {
        display: block;
      }
    }
    .added {
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;
      .order-button {
        font-size: 12px;
        color: #fff;
        height: 28px;
        border: none;
        background: none;
        &.minus {
          color: #fff;
        }
      }
      &.active {
        display: block;
      }
    }
  }
}

.popup-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 50px;
  -webkit-line-clamp: 2; /* Write the number of 
                              lines you want to be 
                              displayed */
  -webkit-box-orient: vertical;
}
</style>